import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSettings } from '../../util/getSettings';
import { getFiltersFromSource } from '../../util/filters';
import { QsStateManager } from '../../util/urls';
import { brandUpdated, filtersUpdated } from '../../redux/actions/filters';

const BrandFilter = ({viewport}) => {
  const settings = getSettings(['century', 'settings']);
  const labels = getSettings(['century', 'labels'], true);
  const filters = useSelector((state) => state.filters);
  const inputName = "brand-radio-" + viewport;

  const [currentFilters, setCurrentFilters] = useState(getFiltersFromSource(filters));
  const { brand: currentBrand } = currentFilters;
  const [selectedBrand, setSelectedBrand] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    setSelectedBrand(currentBrand);
  }, [currentBrand]);

  const handleBrandChange = (brand) => {
    const brandToSet = brand === 'All Brands' ? false : brand;
    setCurrentFilters({ ...currentFilters, brand: brandToSet });
    dispatch(brandUpdated(brandToSet));
    dispatch(filtersUpdated());
    new QsStateManager().addParam('nd', brandToSet).addFilters(filters).doUpdate();
  };

  const onBrandChange = (e) => {
    setSelectedBrand(e.target.value);
    handleBrandChange(e.target.value);
  };

  return (
    <fieldset className="brand-filter-wrapper">
      <legend className='sr-only'>Brands</legend>
      <div className="checkbox-input-container fyh-radio-btn_all">
        <input
          onChange={onBrandChange}
          checked={!selectedBrand || selectedBrand === 'All Brands'}
          name={inputName}
          value="All Brands"
          id={"brandsRadioAll" + viewport}
          type="radio"
          tabIndex="0"
        />
        <label htmlFor={"brandsRadioAll" + viewport}>
          <span className="brand-filter-radio-text">{labels.allCommunitiesLabel}</span>
        </label>
      </div>

      <div className="brand-filter-container brand-filter-container_static">

        <div className="brand-filter-radio-container">
          <input
            className='sr-only'
            onChange={onBrandChange}
            checked={selectedBrand === 'Century Communities'}
            name={inputName}
            value="Century Communities"
            id={"community-" + viewport}
            type="radio"
          />
          <label htmlFor={"community-" + viewport}>
            <img src={settings.centuryCommunityBrandFilterImageUrl} alt='' />
            <span className="sr-only">Century Communities</span>
          </label>
        </div>

        <div className="brand-filter-radio-container">
          <input
            className='sr-only'
            onChange={onBrandChange}
            checked={selectedBrand === 'Century Complete'}
            name={inputName}
            value="Century Complete"
            id={"complete" + viewport}
            type="radio"
          />
          <label htmlFor={"complete" + viewport}>
            <img src={settings.centuryCompleteBrandFilterImageUrl} alt='' />
            <span className="sr-only">Century Complete</span>
          </label>
        </div>
      </div>
    </fieldset>
  );
};

export default BrandFilter;
